import { render } from "./StoreDocumentDialog.vue?vue&type=template&id=23319189&scoped=true"
import script from "./StoreDocumentDialog.vue?vue&type=script&lang=js"
export * from "./StoreDocumentDialog.vue?vue&type=script&lang=js"

import "./StoreDocumentDialog.vue?vue&type=style&index=0&id=23319189&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23319189"]])

export default __exports__